import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService, InternalUser} from '../services/auth.service';
import {map} from 'rxjs/operators';
import {Constants} from "../utils/constants";
import { User } from '../model/user';

@Injectable({
  providedIn: 'root'
})
export class ReservedRoutesGuard {

  roles = Constants.roles;

  constructor(private router: Router, private authService: AuthService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.evaluate(route.data.roles as string[] | undefined, state.url);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.evaluate(route.data.roles as string[] | undefined, state.url);
  }

  private evaluate(routeRoles: string[] | undefined, url: string): Observable<boolean | UrlTree> {
     return this.authService.onUserChange().pipe(
      map((user: User | undefined) => {

        if (!user) {
          this.authService.redirectUrl = url;
          return this.router.createUrlTree(['/login']);
        }

        if (routeRoles?.length && !routeRoles.includes(user.role)) {
          this.authService.redirectUrl = url;
          return this.router.createUrlTree(['/reserved']);
        }

        return true;
      })
    );

  }


}
